import angular from 'angular'
import TakeoverPanelComponent from './takeover-panel.component'

import filters from 'components/filters/filters.js'
import SceneCollectionService from 'common/scenecollection.service'
import composeStepper from '../compose-stepper'

export default angular
  .module('takeoverPanel', [
    // The template shows a length with the duration filter and asks for a
    // number with the stepper, so the panel declares both.
    filters,
    composeStepper,
    SceneCollectionService
  ])
  .component('takeoverPanel', TakeoverPanelComponent)
  .name
